import { useEffect, useState } from 'react'

import { ValidateResponse as BLValidateResponse } from './../../../utilities/BL/Zones'


const Lottery = ({ lottery }) => {
    const { board, boardSize, view, lifes } = lottery
    const [showImage,setShowImage] = useState(false)
    const [showText,setShowText] = useState(false)
    
    const [usedLifes, setUsedLifes] = useState(0)
    const [availableLifes, setAvailableLifes] = useState(0)
    const [validatedCards, setValidatedCards] = useState({}) // { cardId: 'correct' | 'incorrect' }


    const GetLifes = async () => {
        try {
            if (lifes && typeof lifes.total === 'number') {
                const total = lifes.total || 0
                const corrects = lifes.corrects || 0
                const incorrects = lifes.incorrects || 0
                const used = corrects + incorrects
                const available = total - used

                setUsedLifes(used)
                setAvailableLifes(available)

                // Cargar frijolitos preexistentes si vienen en props (opcional)
                if (lifes.cardsAnswered && Array.isArray(lifes.cardsAnswered)) {
                    const preloaded = {}
                    for (const card of lifes.cardsAnswered) {
                        preloaded[card.id] = card.result // 'correct' o 'incorrect'
                    }
                    setValidatedCards(preloaded)
                }
            }
        } catch (error) {
            console.error("❌ Error al obtener vidas:", error)
        }
    }

    // const GetLifes = async () => {
    //     try {
    //         if (lifes && typeof lifes.total === 'number') {
    //             const total = lifes.total || 0
    //             const used = (lifes.corrects || 0) + (lifes.incorrects || 0)
    //             const available = total - used

    //             setUsedLifes(used)
    //             setAvailableLifes(available)
    //         }
    //     } catch (error) {
    //         console.error("❌ Error al obtener vidas:", error)
    //     }
    // }

    // const GetLifes = async () => {
    //     try {
    //         // Ejemplo de info que trae lottery
    //         // const lottery = {
    //         //     view: 1,
    //         //     board: board,
    //         //     boardSize: 2,
    //         //     lifes: {
    //         //         total: 2 * 2,
    //         //         corrects: 1
    //         //         incorrects: 1
    //         //     }
    //         // }
    //     } catch (error) {
            
    //     }
    // }

    const GetDataView = async () => {
        try {
            if (view === 1 || view === 4 || view === 5 || view === 6) {
                setShowImage(true)
            }

            if (view === 1 || view === 3 || view === 5 || view === 6 || view === 7) {
                setShowText(true)
            }
        } catch (error) {
            
        }
    }

    // Dividir el board en filas según el tamaño indicado
    const GetBoardAsRows = (board, size) => {
        try {
            const rows = []
            
            if (lottery.board.length === boardSize * boardSize) {
                for (let i = 0; i < board.length; i += size) {
                    rows.push(board.slice(i, i + size))
                }
            }

            return rows
        } catch (error) {
            
        }
    }

    // const ValidateResponse = async (card) => {
    //     try {
    //         // const response = await BLValidateResponse(card)
    //         //
    //         // if (response.success) {
    //         //     // Pintar fondo verde con baja opacidad e imagen de frijolito
    //         // } else {
    //         //     // Pintar fondo rojo con baja opacidad e imagen de frijolito
    //         // }
    //     } catch (error) {
            
    //     }
    // }

    // const ValidateResponse = async (card) => {
    //     try {
    //         // Simulación de respuesta
    //         // const response = await BLValidateResponse(card.id) // card.id debe existir

    //         // if (response.success) {
    //         //     setValidatedCards(prev => ({ ...prev, [card.id]: 'correct' }))
    //         // } else {
    //         //     setValidatedCards(prev => ({ ...prev, [card.id]: 'incorrect' }))
    //         // }
    //     } catch (error) {
    //         console.error("❌ Error al validar carta:", error)
    //     }
    // }

    const ValidateResponse = async (card) => {
        try {
            // Ignorar si ya tiene frijolito
            if (validatedCards[card.Id]) return
            
            const response = await BLValidateResponse(card.Id)
            
            const result = response.success ? 'correct' : 'incorrect'

            setValidatedCards(prev => ({ ...prev, [card.Id]: result }))

            // Actualiza vidas
            setUsedLifes(prev => prev + 1)
            setAvailableLifes(prev => Math.max(prev - 1, 0))
        } catch (error) {
            console.error("❌ Error al validar carta:", error)
        }
    }

    const LoadPage = async () => {
        try {
            await GetDataView()
            await GetLifes()
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])


    const boardRows = GetBoardAsRows(board, boardSize)


    return (
        <div className="Lottery">
            <div className="Lottery__Lifes">
                {/* Vida sin usar */}
                {/* <img src='/img/games/lottery/1.png' className="Lottery__Lifes__Image" /> */}
                {/* Vida usada */}
                {/* <img src='/img/games/lottery/1--Disabled.png' className="Lottery__Lifes__Image" /> */}

                {/* {[...Array(availableLifes)].map((_, i) => (
                    <img key={`life-${i}`} src="/img/games/lottery/1.png" className="Lottery__Lifes__Image" />
                ))}
                {[...Array(usedLifes)].map((_, i) => (
                    <img key={`used-${i}`} src="/img/games/lottery/1--Disabled.png" className="Lottery__Lifes__Image" />
                ))} */}

                {[...Array(availableLifes)].map((_, i) => (
                    <img key={`life-${i}`} src="/img/games/lottery/1.png" className="Lottery__Lifes__Image" />
                ))}
                {[...Array(usedLifes)].map((_, i) => (
                    <img key={`used-${i}`} src="/img/games/lottery/1--Disabled.png" className="Lottery__Lifes__Image" />
                ))}
            </div>

            <table className="Lottery__Table">
                <tbody className="Lottery__Table__Body">
                    {boardRows.map((row, rowIndex) => (
                        <tr key={rowIndex} className="Lottery__Table__Body__Row">
                            {row.map((card, colIndex) => (
                                // <td key={colIndex} className="Lottery__Table__Body__Cell">
                                //     <button type="button" className="Lottery__Table__Body__Cell__Button" onClick={() => ValidateResponse(card)}>
                                //         {showImage && (
                                //             <img src={card.ImgPath} className="Lottery__Table__Body__Cell__Button__Image" />
                                //         )}

                                //         {showText && (
                                //             <p className={`Lottery__Table__Body__Cell__Button__Text ${showImage && 'Lottery__Table__Body__Cell__Button__Text--Limited'}`}>{card.Text}</p>
                                //         )}
                                //     </button>

                                //     {validatedCards[card.id] && (
                                //         <div className={`Lottery__Overlay Lottery__Overlay--${validatedCards[card.id]}`}>
                                //             <img src="/img/games/lottery/1.png" className="Lottery__Overlay__Bean" />
                                //         </div>
                                //     )}
                                // </td>

                                <td key={colIndex} className="Lottery__Table__Body__Cell">
                                    <div className="Lottery__Table__Body__Cell__Wrapper" style={{ position: 'relative' }}>
                                        <button
                                            type="button"
                                            className="Lottery__Table__Body__Cell__Button"
                                            onClick={() => ValidateResponse(card)}
                                            disabled={!!validatedCards[card.id]} // evita múltiples clics
                                        >
                                            {showImage && (
                                                <img src={card.ImgPath} className="Lottery__Table__Body__Cell__Button__Image" />
                                            )}

                                            {showText && (
                                                <p className={`Lottery__Table__Body__Cell__Button__Text ${showImage && 'Lottery__Table__Body__Cell__Button__Text--Limited'}`}>
                                                    {card.Text}
                                                </p>
                                            )}
                                        </button>

                                        {validatedCards[card.id] && (
                                            <div className={`Lottery__Overlay Lottery__Overlay--${validatedCards[card.id]}`}>
                                                <img src="/img/games/lottery/1.png" className="Lottery__Overlay__Bean" />
                                            </div>
                                        )}
                                    </div>
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export { Lottery };